import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const imgUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export const isVideo = (u) => /\.(mp4|mov|webm)$/i.test(u || "");

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const track = (event, params = {}) => {
  if (window.gtag) window.gtag("event", event, params);
};

export const SERVICES_LIST = [
  "Interior Painting", "Exterior Painting", "Flooring", "Tile", "Vinyl Flooring",
  "Waterproofing", "Custom Showers", "Drywall", "Remodeling", "General Construction Services", "Other",
];

export const GALLERY_CATEGORIES = ["Painting", "Flooring", "Tile", "Bathrooms", "Remodeling", "Construction", "Other"];

export const LEAD_STATUSES = ["New", "Contacted", "Estimate Scheduled", "Estimate Sent", "Won", "Lost", "Closed"];
